import React from "react";
import { SvgIcon } from "@mui/material";
import { Height } from "@mui/icons-material";

function BackIcon(props) {
  return (
    <SvgIcon {...props} sx={{ height: "16px", width: "16px" }}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.29695 13.6209L2.21188 8.53587C2.13483 8.45883 2.08013 8.37536 2.04777 8.28547C2.01592 8.19559 2 8.09928 2 7.99655C2 7.89382 2.01592 7.79751 2.04777 7.70762C2.08013 7.61774 2.13483 7.53427 2.21188 7.45722L7.29695 2.37215C7.4382 2.2309 7.61464 2.15694 7.82626 2.15026C8.03839 2.14409 8.22151 2.21806 8.3756 2.37215C8.52969 2.5134 8.61008 2.68984 8.61676 2.90146C8.62292 3.1136 8.54896 3.29671 8.39486 3.4508L4.61958 7.22608H13.2295C13.4478 7.22608 13.6309 7.29979 13.7789 7.44721C13.9263 7.59514 14 7.77825 14 7.99655C14 8.21485 13.9263 8.3977 13.7789 8.54512C13.6309 8.69305 13.4478 8.76701 13.2295 8.76701H4.61958L8.39486 12.5423C8.53612 12.6835 8.61008 12.8633 8.61676 13.0816C8.62292 13.2999 8.54896 13.4797 8.39486 13.6209C8.25361 13.775 8.07384 13.8521 7.85554 13.8521C7.63724 13.8521 7.45104 13.775 7.29695 13.6209Z"
          fill="#57B6D9"
        />
      </svg>
    </SvgIcon>
  );
}

export default BackIcon;
